(function () {
  if (customElements.get('recipient-form')) return;

  class RecipientForm extends HTMLElement {
    connectedCallback() {
      if (this._initialised) return;
      this._initialised = true;

      this.emailInput = this.querySelector('[data-recipient-email]');
      this.confirmEmailInput = this.querySelector('[data-recipient-email-confirm]');
      this.confirmErrorEl = this.querySelector('[data-recipient-email-confirm-error]');
      this.form = this.closest('form');

      this.bindEvents();
    }

    bindEvents() {
      if (this.confirmEmailInput) {
        this.confirmEmailInput.addEventListener('input', () => this.validateConfirmEmail());
        this.confirmEmailInput.addEventListener('blur', () => this.validateConfirmEmail());
      }
      if (this.emailInput) {
        this.emailInput.addEventListener('input', () => this.validateConfirmEmail());
      }
      if (this.form) {
        this.form.addEventListener('submit', (event) => this.handleSubmit(event));
      }
    }

    emailsMatch() {
      if (!this.emailInput || !this.confirmEmailInput) return true;
      if (!this.confirmEmailInput.value) return false;
      return this.emailInput.value.trim().toLowerCase() === this.confirmEmailInput.value.trim().toLowerCase();
    }

    validateConfirmEmail() {
      if (!this.confirmEmailInput) return true;
      const match = this.emailsMatch();
      if (match) {
        this.confirmEmailInput.setCustomValidity('');
        this.confirmEmailInput.removeAttribute('aria-invalid');
        if (this.confirmErrorEl) this.confirmErrorEl.hidden = true;
      } else {
        const message = this.confirmErrorEl
          ? this.confirmErrorEl.textContent.trim()
          : 'Email addresses do not match';
        this.confirmEmailInput.setCustomValidity(message);
        this.confirmEmailInput.setAttribute('aria-invalid', 'true');
        if (this.confirmErrorEl) this.confirmErrorEl.hidden = false;
      }
      return match;
    }

    handleSubmit(event) {
      if (!this.validateConfirmEmail()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.confirmEmailInput) {
          this.confirmEmailInput.reportValidity();
          this.confirmEmailInput.focus();
        }
        return;
      }
      if (this.emailInput) {
        this.emailInput.value = this.emailInput.value.trim();
      }
    }
  }

  customElements.define('recipient-form', RecipientForm);
})();
